import React, { useEffect, useState } from 'react';
import { CustomImportSource as CustomImportSourceType } from 'types/CitationImport';
import CitationImportSourceDropDown from '../components/CitationImportSourceDropDown';
import ReviewCitationSourcesModal from '../components/ReviewCitationSourcesModal';
import { Link, Text } from 'components/core';
import { getReviewImportSources } from 'query/review';
import { Stack } from 'components/layout';

export const GetReviewImportSourcesErrorMessage =
  'Unable to load sources, please try again later';

type UncontrolledProps = {
  name: string;
  label?: string;
};

type ControlledProps = {
  onChange: (value: string) => void;
  value: string;
  label?: string;
};

type Props = UncontrolledProps | ControlledProps;

const CitationImportSource = (props: Props) => {
  const [isOpenSourceModal, setIsOpenSourceModal] = useState(false);
  const [reviewImportSources, setReviewImportSources] = useState<string[]>([]);
  const [getSourcesError, setGetSourcesError] = useState<string>();
  const [customReviewImportSources, setCustomReviewImportSources] = useState<
    CustomImportSourceType[]
  >([]);
  const detailsId = 'citation-source-details';

  useEffect(() => {
    getReviewImportSources()
      .then(({ reviewImportSources, customReviewImportSources }) => {
        setReviewImportSources(reviewImportSources);
        setCustomReviewImportSources(customReviewImportSources);
      })
      .catch(() => {
        setGetSourcesError(GetReviewImportSourcesErrorMessage);
      });
  }, []);

  return (
    <Stack spacing={2}>
      <CitationImportSourceDropDown
        {...props}
        options={reviewImportSources}
        error={getSourcesError}
        detailsId={detailsId}
      />
      <div id={detailsId}>
        <Text component="span" variant="weak">
          Cannot find the source you need?{' '}
        </Text>
        <Link
          variant="primary"
          component="button"
          htmlType="button"
          onClick={() => setIsOpenSourceModal(true)}
        >
          Manage sources
        </Link>
      </div>

      {isOpenSourceModal && (
        <ReviewCitationSourcesModal
          isOpen={isOpenSourceModal}
          setIsOpen={setIsOpenSourceModal}
          reviewImportSources={reviewImportSources}
          setReviewImportSources={setReviewImportSources}
          customReviewImportSources={customReviewImportSources}
          setCustomReviewImportSources={setCustomReviewImportSources}
        />
      )}
    </Stack>
  );
};

export default CitationImportSource;
